module.exports = __webpack_public_path__ + "img/04-info-icon.8b226e7a.svg";